const state = {
    disneyShowFlag: false,
    disneyTransactionKey: null
};

const mutations = {
    setDisneyShowFlag(state, showFlag) {
        console.log('setDisneyShowFlag mutations', showFlag);
        state.disneyShowFlag = showFlag;
        console.log('after setDisneyShowFlag mutations', state.disneyShowFlag);
    },
    setDisneyTransactionKey(state, transactionKey) {
        state.disneyTransactionKey = transactionKey;
    }
};

const actions = {
    setDisneyShowFlag({commit}, showFlag) {
        console.log('setDisneyShowFlag', showFlag);
        commit('setDisneyShowFlag', showFlag);
    },
    setDisneyTransactionKey({commit}, transactionKey) {
        commit('setDisneyTransactionKey', transactionKey);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}; 